import { parseBool, parseIntFromString } from '@/utils/parse-functions';

export default [
	{
		path: 'service/labor-time-guide',
		name: 'laborTimeGuide',
		meta: {
			pageTitle: 'Labor Time Guide',
			hideNavigation: true
		},
		props: route => ({
			vin: route.query.vin,
			modelYear: parseIntFromString(route.query.modelYear),
			modelName: route.query.modelName,
			manufacturerId: parseIntFromString(route.query.manufacturerId),
			frame: parseBool(route.query.frame)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "deal" */ '@/sections/service/labor-time-guide/labor-time-guide-page.vue'
			)
	}
];
